export interface IUIState { }

export const DEFAULT_UI_STATE: IUIState = {};
